import { useMemo } from 'react';
import { useQuery } from '@apollo/client';
import { GET_DRIVER_ACTIVITY_RULE_TEMPLATE, GetDriverActivityRuleTemplateResponse } from '../graphql/queries';
import { DriverActivityRuleTemplate } from '../graphql/types';
import { FALLBACK_RULE_TEMPLATE } from '../utils/ruleTextUtils';

/**
 * 规则文案模板（段定义、变量、语言、字数上限、三语默认文案）由后端下发。
 * 查询失败时退回 FALLBACK_RULE_TEMPLATE 保证页面可渲染，默认文案为空。
 */
export function useRuleTemplate(): { template: DriverActivityRuleTemplate; loading: boolean; error?: Error } {
    const { data, loading, error } = useQuery<GetDriverActivityRuleTemplateResponse>(GET_DRIVER_ACTIVITY_RULE_TEMPLATE, {
        fetchPolicy: 'cache-first',
    });
    const template = useMemo(() => {
        const remote = data?.getDriverActivityRuleTemplate;
        if (!remote?.sections?.length || !remote.languages?.length) return FALLBACK_RULE_TEMPLATE;
        return {
            ...remote,
            sections: [...remote.sections].sort((a, b) => a.order - b.order),
            defaultTexts: remote.defaultTexts ?? [],
        };
    }, [data]);
    return { template, loading, error };
}
